"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultAboutOwner = void 0;
var defaultAboutOwner = exports.defaultAboutOwner = {
  ownerBirthdateInput: {
    defaultValue: '1900-01-01'
  }
};